import {FC} from 'react';
import {getPaymentStatusTitle} from '../../helpers';
import {HistoryStatusProps} from '../../types/balance-history.types';
import {StatusBadge} from './styles';

export const HistoryStatus: FC<HistoryStatusProps> = ({status}): JSX.Element | null => {
  if (!status) return null;
  const key = status.toLowerCase();
  return <StatusBadge statusKey={key}>{getPaymentStatusTitle(status)}</StatusBadge>;
};
